import virtual from "@pdfking/workflow/vue/3/virtual"
import scan from "rfuncs/functions/scan"

import serialize_error from "../utils/serialize_error"
import user from "./user"

export default virtual({
  data: () => {
    return {
      IS_SUBMITTED: false,
      LAST_FOCUS: null,
      AJAX_REQUEST_CACHE: {},
      AJAX_COUNTER: 0,

      request_id: null,
      event_handlers: [],
      settings: {},
    }
  },
  methods: {
    track_event(...args) {
      scan(func => func(...args), this.event_handlers)
    },
    track_error(error, error_type) {
      this.track_event(`${error}`, error_type)
      serialize_error(error)
    },
  },
  computed: {
    user() {
      return user
    },
  },
})
